export const COLOR = {
	ACTIVE: '#000000',
	INACTIVE: '#FFFFFF',
};

export const SORT_COLOR_MAPPING = {
	ASC: {
		UP: COLOR.ACTIVE,
		DOWN: COLOR.INACTIVE,
	},
	DESC: {
		UP: COLOR.INACTIVE,
		DOWN: COLOR.ACTIVE,
	},
};

export const DIRECTION : {[key:string]: Direction} =  {
  ASC: "ASC",
  DESC: "DESC",
}